'use strict';

import {getLabcodeApiBaseUrl} from './labcode-api';

/**
 * @returns {'full'|'upload'|'off'}
 */
export function getLabcodeAuthMode () {
    const kill = typeof process !== 'undefined' && process.env && process.env.REACT_APP_LABCODE_AUTH_DISABLE;
    if (kill === '1' || kill === 'true' || kill === true) {
        return 'off';
    }
    const raw = typeof process !== 'undefined' && process.env && process.env.REACT_APP_LABCODE_AUTH_MODE;
    if (!raw || raw === '0' || raw === 'off' || raw === 'false') {
        return 'off';
    }
    const s = String(raw).toLowerCase();
    if (s === 'full') return 'full';
    if (s === 'upload') return 'upload';
    return 'off';
}

export function isLabcodeFullAuthGateActive () {
    return getLabcodeAuthMode() === 'full' && Boolean(getLabcodeApiBaseUrl());
}

export function isLabcodeUploadAuthRequired () {
    return getLabcodeAuthMode() === 'upload' && Boolean(getLabcodeApiBaseUrl());
}
